import cx from 'classnames';
import {useTranslation} from 'react-i18next';

import {Button} from 'components';
import {TRANSLATION_KEYS} from 'locale';

type Props = {
    className?: string;
    onClick: () => void;
}

const T_KEYS = TRANSLATION_KEYS.IN_SESSION_PAGE.SIP_MESSAGES_SIDEBAR;

export const IbmMessageHistoryButton: React.FC<Props> = ({className, onClick}) => {
    const {t} = useTranslation();

    return (
        <Button className={cx(className, 'tw-mx-auto')} onClick={onClick}>
            {t(T_KEYS.INTEGRATIONS.SHOW_MESSAGES)}
        </Button>
    );
};